import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import PrivateRoute from './auth/PrivateRoute';
import Layout from './components/Layout';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import VerifyEmail from './pages/VerifyEmail';
import DashboardAssinante from './pages/assinante/DashboardAssinante';
import FormularioCredor from './pages/assinante/FormularioCredor';
import FormularioDevedor from './pages/assinante/FormularioDevedor';
import PainelCobranca from './pages/assinante/PainelCobranca'
import CriarAcordo from './pages/assinante/CriarAcordo';
import AssinaturaAcordo from './pages/AssinaturaAcordo';
import ListaAcordos from './pages/assinante/ListaAcordos';
import ConectarWhatsapp from './pages/assinante/ConectarWhatsapp';
import CheckoutPage from './pages/CheckoutPage';

import './styles/global.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route element={<Layout />}>
            {/* Rotas Públicas */}
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/registrar" element={<Register />} />
            <Route path="/publico/verificar-email" element={<VerifyEmail />} />
            <Route path="/acordo/:token" element={<AssinaturaAcordo />} />
            <Route path="/checkout/:token" element={<CheckoutPage />} />


            {/* Rotas de Assinante */}
              <Route element={<PrivateRoute allowedRoles={['ASSINANTE']} />}>
              <Route path="/dashboard" element={<DashboardAssinante />} />
              <Route path="/credores/novo" element={<FormularioCredor />} />
              <Route path="/devedores/novo" element={<FormularioDevedor />} />
              <Route path="/cobranca" element={<PainelCobranca />} />
              <Route path="/acordo/criar/:dividaId" element={<CriarAcordo />} />
              <Route path="/acordos" element={<ListaAcordos />} />
              <Route path="/configuracoes/whatsapp" element={<ConectarWhatsapp />} />
              <Route path="/credores" element={<div>Gerenciar Credores</div>} />
            </Route>

            {/* Rotas de Admin */}
            <Route element={<PrivateRoute allowedRoles={['ADMIN']} />}>
              <Route path="/admin" element={<div>Painel Administrativo</div>} />
            </Route>
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;